// Debug utility for controlling console logs
const DEBUG_MODE = process.env.REACT_APP_DEBUG_MODE === 'true';

export const debugLog = (...args) => {
    if (DEBUG_MODE) {
        console.log(...args);
    }
};

export const debugError = (...args) => {
    if (DEBUG_MODE) {
        console.error(...args);
    }
};

export const debugWarn = (...args) => {
    if (DEBUG_MODE) {
        console.warn(...args);
    }
};

export const debugInfo = (...args) => {
    if (DEBUG_MODE) {
        console.info(...args);
    }
}; 
